import { Component, OnInit, Input, OnChanges, SimpleChanges, Output, EventEmitter } from '@angular/core';
import { FormBuilder, Validators, FormGroup } from '@angular/forms';
import { Store } from '@ngrx/store';
import { CoalService } from 'app/services/coal.service';
import { AppState, selectAuthState, selectUtilsState } from 'app/store/app.states';
import { MostrarSpinner, OcultarSpinner } from 'app/store/actions/utils.action';
import { MatSnackBar, MatSnackBarConfig } from '@angular/material/snack-bar';
import { FileService } from 'app/services/file.service';
import { EstatusEmpresa } from 'app/shared/enum.shared';
import { MatDialog } from '@angular/material/dialog';
import { ConfirmDialogOkComponent } from 'app/utilerias/confirm-dialog-ok/confirm-dialog-ok.component';
import { BehaviorSubject, Subscription, switchMap, take, withLatestFrom } from 'rxjs';
import { AuthService} from 'app/services/auth.service';
import { SeleccionarEmpresa } from 'app/store/actions/utils.action';

@Component({
    selector: 'app-wiz-sellos',
    templateUrl: './wiz-sellos.component.html',
    styleUrls: ['./wiz-sellos.component.scss']
})
export class WizSellosComponent {
    @Input() idEmpresa;
    @Input() status;
    @Input() Observable$: BehaviorSubject<any>;
    @Input() stampForm: FormGroup;

    @Output() fileCerChange: EventEmitter<any> = new EventEmitter<any>();
    @Output() fileKeyChange: EventEmitter<any> = new EventEmitter<any>();

    fileKey;
    fileCer;
    files;
    noCertificado;
    vigencia;
    cargarArchivos: boolean = false;
    loadCer: boolean = false;
    loadKey: boolean = false;
    cargando: boolean = false;
    private subsSingIn: Subscription;

    constructor(
        private _formBuilder: FormBuilder,
        private _authService: AuthService,
        private store: Store<AppState>,
        private coalService: CoalService,
        private snackBar: MatSnackBar,
        private fileService: FileService,
        private dialog: MatDialog
    ) {
        this.subsSingIn = new Subscription();
    }
    ngOnInit(): void {
        this.getDigitalStamp();
    }

    ngOnChanges(changes: SimpleChanges): void {
        // if (changes?.idEmpresa?.currentValue) {
        //     this.getDigitalStamp();
        // }
        // if (this.status === EstatusEmpresa.Prerregistro || this.status === null || this.status === undefined) {
        //     this.stampForm?.controls?.contrasenia?.disable();
        //     this.cargarArchivos = false;
        //     const dialogRef = this.dialog.open(ConfirmDialogOkComponent, {
        //         width: '450px',
        //         data: 'Debe completar sus datos de facturación para poder cargar sus archivos de sellos digitales'
        //     });
        //     dialogRef.afterClosed().subscribe((result) => { });
        // }
        // else {
        //     this.stampForm?.controls?.contrasenia?.enable();
        //     this.cargarArchivos = true;
        // }
    }

    getDigitalStamp() {
        // this.clearForm();
        // this.store.dispatch(MostrarSpinner());
        this.coalService.getService(`ope-empresas?filters[id]=${this.idEmpresa}&populate=ope_empresa_emisors.cer,ope_empresa_emisors.key`)
            .subscribe((res: any) => {
                // this.store.dispatch(OcultarSpinner());
                this.files = res.data[0]?.attributes?.ope_empresa_emisors?.data[0];
                this.noCertificado = this.files?.attributes?.noCertificado;
                this.vigencia = this.files?.attributes?.fechaVigencia;
                this.stampForm?.controls?.contrasenia?.setValue(this.files?.attributes?.password);
            }, (error: any) => {
                // this.store.dispatch(OcultarSpinner());
            })
    }

    // clearForm() {
    //     this.loadCer = false;
    //     this.loadKey = false;
    //     this.stampForm.controls.cer.setValue(null);
    //     this.stampForm.controls.key.setValue(null);
    //     this.stampForm.controls.contrasenia.setValue(null);
    // }

    fileBrowseHandlerCer(file) {
        this.loadCer = true;
        this.openSnackBar("Archivo cargado correctamente");
        this.fileCer = file.file[0];
        this.fileCerChange.emit(this.fileCer);
        if(this.stampForm){
            this.stampForm.controls.cer.setValue(true);
        }
    }

    fileBrowseHandlerKey(file) {
        this.loadKey = true;
        this.openSnackBar("Archivo cargado correctamente");
        this.fileKey = file.file[0];
        this.fileKeyChange.emit(this.fileKey); 
        if(this.stampForm){
            this.stampForm.controls.key.setValue(true);
        }
    }

    uploadFile() {
        // this.infoUserModule();
        // return false;

        this.stampForm.markAllAsTouched();
        if (!this.stampForm.valid || !this.fileCer || !this.fileKey) {
            this.openSnackBar("Favor de cargar los documentos necesarios y/o ingresar la contraseña", 5000, 'fill', 'error');
            return;
        }

        let params = {
            data: {
                cer: this.fileCer.id,
                key: this.fileKey.id,
                idEmpresa: this.idEmpresa,
                password: this.stampForm.value.contrasenia
            }
        }

        this.cargando = true;
        // this.store.dispatch(MostrarSpinner());
        this.coalService.postService('ope-empresa-emisores', params)
            .subscribe((res: any) => {
                this.cargando = false;
                this.cargarArchivos = false;
                // this.store.dispatch(OcultarSpinner());
                this.openSnackBar("Archivos cargados correctamente");
                this.infoUserModule();
                this.Observable$.next(1);

            }, (error: any) => {
                this.cargando = false;
                // this.store.dispatch(OcultarSpinner());
                let message = (error?.error?.error?.message ?? false) ? 'No pudimos procesar tu solicitud por la siguiente razón: ' + error?.error?.error?.message + '. Por favor, verifica tu información y vuelve a intentarlo.' : "Ocurrió un error al procesar los archivos";
                // this.openSnackBar(error?.error?.error?.message || "Ocurrió un error al procesar los archivos", 10000);
                this.openSnackBar(message, 10000, 'outline', 'error');
            })
    }

    infoUserModule() {
        this.store.select(selectAuthState).pipe(
            take(1), // Esto asegura que sólo tomes la primera emisión y luego te desuscribas
            switchMap((state: any) => {
                const userId = state.seguridad.user.id;
                return this.coalService.getService(`ope-empresas?filters[users_permissions_users][id]=${userId}&populate=logo,ope_empresa_estatus_hs.ope_empresa_estatus&sort=createdAt:ASC`);
            }),
            withLatestFrom(this.store.select(selectUtilsState)) // Con esto combinas el observable anterior con el estado actual de utils
        ).subscribe(([res, utilsState]: [any, any]) => {
            const empresaSeleccionada = utilsState?.empresaSeleccionada?.id;
            const filteredEmpresa = res.data.find(empresa => empresa.id === empresaSeleccionada);
            // this.store.dispatch(SeleccionarEmpresa({ empresaSeleccionada: filteredEmpresa }));
            localStorage.setItem("empresaSeleccionada", JSON.stringify(filteredEmpresa));

            // if (!filteredEmpresa || filteredEmpresa.id !== empresaSeleccionada) {
            //   // Verifica si la empresa seleccionada es diferente antes de despachar la acción
            //   // this.store.dispatch(SeleccionarEmpresa({ empresaSeleccionada: filteredEmpresa }));
            //   localStorage.setItem("empresaSeleccionada", JSON.stringify(filteredEmpresa));
            // }
        }, (error: any) => {
            // this.store.dispatch(OcultarSpinner());
        });
    }


    // infoUserModule() {
    //   this.store.select(selectAuthState).subscribe((state: any) => {
    //       const userId = state.seguridad.user.id;
    //       this.coalService.getService(`ope-empresas?filters[users_permissions_users][id]=${userId}&populate=logo,ope_empresa_estatus_hs.ope_empresa_estatus&sort=createdAt:ASC`)
    //         .subscribe((res: any) => {
    //           this.store.select(selectUtilsState).subscribe((state: any) => {
    //             const empresaSeleccionada = state.empresaSeleccionada.id;
    //             const filteredEmpresa = res.data.find(empresa => empresa.id === empresaSeleccionada);

    //             // this.store.dispatch( SeleccionarEmpresa({ empresaSeleccionada: filteredEmpresa }));
    //             // localStorage.setItem("empresaSeleccionada", JSON.stringify(filteredEmpresa));
    //         });
    //       }, (error: any) => {
    //           // this.store.dispatch(OcultarSpinner());
    //       })
    //   });
    // }

    downloadFile(file) {
        this.fileService.downloadFile(file?.data[0].attributes?.url, file?.data[0].attributes?.name)
            .subscribe(() => { });
    }

    openSnackBar(
        message: string,
        duration: number = 5000,
        appearance: 'fill' | 'outline' | 'soft' = 'fill',
        type: 'info' | 'success' | 'error' = 'info'
    ): void {
        const config: MatSnackBarConfig = {
            duration: duration,
            verticalPosition: 'bottom',
            horizontalPosition: 'center',
            panelClass: [`snackbar-type-${appearance}-${type}`],
        };
        this.snackBar.open(message, 'Ok', config);
    }
}
